module.exports = __webpack_public_path__ + "img/logos_feder.42ed7908.png";